// import * as Diag from "VSS/Diag";
/// <amd-module name="Work/Views/MyWork/Telemetry" />
import { IVssPageContext } from 'VSS/Platform/Context';
import { IVssTelemetryService } from 'VSS/Platform/Telemetry';

export namespace TelemetryConstants {
    export const Area = "MyWorkList";
}

/**
 * Helper for new my work page usage telemetry
 */
export namespace UsageTelemetryHelper {
    
    /**
     * Publishes usage telemetry for click activity on dropdowns in the new My Work experience.
     * @param pageContext Context of the page.
     * @param groupName Name of the dropdown group being clicked.
     * @param wasCollapsed True if the group was collapsed before being clicked. False if otherwise.
     */
    export function publishMyWorkDropdownClickActivity(pageContext: IVssPageContext, groupName: string, wasCollapsed: boolean): void {
        const service = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        service.publishEvent(TelemetryConstants.Area, groupName, { wasCollapsed });
    }
}
